import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import useIsMobile from '../../hooks/useIsMobile';

const typeIcons = {
  checking: '🏦',
  savings: '💰',
  brokerage: '📈',
  retirement: '🪙',
  crypto: '🪙',
};

const AccountCards = ({ accounts }) => {
  const isMobile = useIsMobile();
  
  return (
    <View style={[styles.container, isMobile && styles.mobileContainer]}>
      {accounts.map((acc) => (
        <View key={acc.name} style={[styles.card, isMobile && styles.mobileCard]}>
          <View style={styles.cardHeader}>
            <Text style={styles.icon}>{typeIcons[acc.type] || '💼'}</Text>
            <View style={styles.accountInfo}>
              <Text style={styles.accountName}>{acc.name}</Text>
              <Text style={styles.institutionName}>
                {acc.institution} 
                <Text style={styles.accountType}> ({acc.type.replace('_', ' ')})</Text>
              </Text>
            </View>
          </View>
          <Text style={styles.balance}>${acc.balance.toLocaleString()}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    marginBottom: 24,
  },
  mobileContainer: {
    flexDirection: 'column',
    gap: 12,
  },
  card: {
    flex: 1,
    minWidth: 280,
    maxWidth: 400,
    backgroundColor: '#F9FAFB',
    borderRadius: 16,
    paddingHorizontal: 24,
    paddingVertical: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
    justifyContent: 'space-between',
  },
  mobileCard: {
    minWidth: '100%',
    maxWidth: '100%',
    flex: 0,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 8,
  },
  icon: {
    fontSize: 32,
    lineHeight: 40,
  },
  accountInfo: {
    flex: 1,
  },
  accountName: {
    fontSize: 16,
    fontWeight: '500',
    color: '#374151',
    marginBottom: 2,
  },
  institutionName: {
    fontSize: 14,
    color: '#6B7280',
  },
  accountType: {
    fontSize: 12,
    color: '#9CA3AF',
  },
  balance: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#111827',
    marginTop: 4,
  },
});

export default AccountCards; 